<template>
  <div>
    <div v-if="tooltip">
      <Tooltip :content="val" :placement="placement" max-width="200">
        <div style="cursor: pointer">{{text}}</div>
      </Tooltip>
    </div>
    <div v-if="!tooltip">
      {{text}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextToolip',
  props: {
    val: {
      required: true
    },
    len: {
      default: 10
    },
    placement: {
      default: 'top'
    }
  },
  data () {
    return {
      text: '',
      tooltip: false
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      if (this.val.length > this.len) {
        this.text = this.val.substring(0, this.len) + '...'
        this.tooltip = true
      } else {
        this.text = this.val
        this.tooltip = false
      }
    }
  },
  watch: {
    val: {
      handler (n, o) {
        this.initData()
      },
      deep: true
    }
  }
}
</script>
